<template>
      <ToggleButton v-model="balanceFrozen" onIcon="pi pi-lock" offIcon="pi pi-lock-open" onLabel="Balance" offLabel="Balance" />

      <DataTable :value="customers" scrollable scrollHeight="400px" class="mt-6">
          <Column field="name" header="Name" style="min-width: 200px" frozen class="font-bold"></Column>
          <Column field="id" header="Id" style="min-width: 100px"></Column>
          <Column field="name" header="Name" style="min-width: 200px"></Column>
          <Column field="country.name" header="Country" style="min-width: 200px"></Column>
          <Column field="date" header="Date" style="min-width: 200px"></Column>
          <Column field="company" header="Company" style="min-width: 200px"></Column>
          <Column field="status" header="Status" style="min-width: 200px"></Column>
          <Column field="activity" header="Activity" style="min-width: 200px"></Column>
          <Column field="representative.name" header="Representative" style="min-width: 200px"></Column>
          <Column field="balance" header="Balance" style="min-width: 200px" alignFrozen="right" :frozen="balanceFrozen">
              <template #body="{ data }">
                  <span class="font-bold">{{ formatCurrency(data.balance) }}</span>
              </template>
          </Column>
      </DataTable>
</template>

<script lang="ts" setup>
import { ref } from 'vue';

const customers = ref([
    {
      "id": "C001",
      "name": "John Doe",
      "country": { "name": "United States" },
      "date": "2024-08-12",
      "company": "TechCorp",
      "status": "Active",
      "activity": "Purchase",
      "representative": { "name": "Alice Johnson" },
      "balance": 1500.75
    },
    {
      "id": "C002",
      "name": "Jane Smith",
      "country": { "name": "Canada" },
      "date": "2024-07-30",
      "company": "HealthPlus",
      "status": "Inactive",
      "activity": "Inquiry",
      "representative": { "name": "Bob Brown" },
      "balance": 250.00
    },
    {
      "id": "C003",
      "name": "Michael Lee",
      "country": { "name": "United Kingdom" },
      "date": "2024-08-05",
      "company": "FinServe",
      "status": "Active",
      "activity": "Consultation",
      "representative": { "name": "Charlie Davis" },
      "balance": 5000.00
    },
    {
      "id": "C004",
      "name": "Emily Davis",
      "country": { "name": "Australia" },
      "date": "2024-08-01",
      "company": "EduWorld",
      "status": "Pending",
      "activity": "Follow-up",
      "representative": { "name": "Diana Evans" },
      "balance": 3200.45
    },
    {
      "id": "C005",
      "name": "David Johnson",
      "country": { "name": "Germany" },
      "date": "2024-07-28",
      "company": "AutoMakers",
      "status": "Active",
      "activity": "Order",
      "representative": { "name": "Edward Harris" },
      "balance": 780.00
    }
  ]);
const balanceFrozen = ref(false);
const formatCurrency = (value) => {
  return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
};
</script>
